import React from "react";
import { Accordion, Table } from "react-bootstrap";
import './AccordianScoreCard.css';

const DynamicAccordion = ({ data }) => {

  if (!Array.isArray(data) || data.length === 0) {
    return <p>No data available</p>;
  }

  const renderTable = (rows) => {
    if (!Array.isArray(rows) || rows.length === 0) {
      return <p>No data available</p>;
    }

    const columns = Object.keys(rows[0]);

    return (
      <Table bordered hover size="sm" className="AccordionTable">
        <thead>
          <tr>
            {columns.map((col) => (
              <th key={col}>{col}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row, rowIndex) => (
            <tr key={rowIndex}>
              {columns.map((col) => (
                <td key={col}>
                  {row[col] !== null ? row[col] : "-"}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </Table>
    );
  };

  return (
    <Accordion defaultActiveKey="0">
      {data.map((item, itemIndex) =>
        Object.keys(item).map((sectionKey, sectionIndex) => (
          <Accordion.Item
            eventKey={`${itemIndex}-${sectionIndex}`}
            key={`${itemIndex}-${sectionIndex}`}
          >
            <Accordion.Header>{sectionKey}</Accordion.Header>
            <Accordion.Body className="accordion-table-x-scroll">
              {renderTable(item[sectionKey])}
            </Accordion.Body>
          </Accordion.Item>
        ))
      )}
    </Accordion>
  );
};

export default DynamicAccordion;
